// Scoring + persistence. Run points use the incremental rule (3,5,7,9,…), doubled
// while the green ×2 bonus is active (ТЗ 3.5.4/3.5.6). Event points + best + goal
// persist in localStorage (try/catch — old WebView may block it in private mode).
import {
  SCORE_BASE, SCORE_STEP, GOAL_POINTS, KEY_POINTS, KEY_BEST, KEY_GOAL,
} from './config';
import { Score } from './types';

function read(key: string): number {
  try { return Number(localStorage.getItem(key)) || 0; } catch { return 0; }
}
function write(key: string, val: number): void {
  try { localStorage.setItem(key, String(val)); } catch { /* in-memory only */ }
}

export function loadScore(): Score {
  return {
    run: 0,
    event: read(KEY_POINTS),
    best: read(KEY_BEST),
    goal: read(KEY_GOAL) || GOAL_POINTS,
    passInDive: 0,
    passStreak: 0,
    bonusUntil: 0,
  };
}

export function savePoints(s: Score): void { write(KEY_POINTS, s.event); }
export function saveGoal(s: Score): void { write(KEY_GOAL, s.goal); }
export function saveBest(s: Score): void { write(KEY_BEST, s.best); }

/** Points awarded for passing a platform, given the 1-based pass count in this dive. */
export function passGain(passInDive: number, bonusActive: boolean): number {
  const base = SCORE_BASE + SCORE_STEP * (passInDive - 1);
  return bonusActive ? base * 2 : base;
}
